"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    button {
        font-size: initial;
        padding: 0;
    }
    .buttonContainer {
        margin-top: 50px;
        .btn {
            margin: 0 1em;
        }
    }
    .successMac {
        p {
            color: #1e1e1e;
        }
    }
    .successMobile {
        .squareButton {
            margin-top: 50px;
        }
    }
    .alternateDownload {
        margin-top: 30px;
        text-align: center;
        a {
            font-size: 0.8em;
        }
    }
`;
//# sourceMappingURL=SuccessStageStyled.js.map